import { useSyncExternalStore } from 'react'
import { CollectionState } from '../collection-state'

export function useViewFields (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('viewFieldsChanged', callback),
    () => state.viewFields
  )
}
